"use strict";
/**
 * @module Serialisers
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
var BytesSerialiserClass = /** @class */ (function () {
    function BytesSerialiserClass() {
    }
    /**
     * Read a Buffer stream
     *
     * @param  output    the stream from which to read
     * @return           the value read from the stream if it is a valid enum value
     *
     * @throws an error if the value read is not a valid enum value
     */
    BytesSerialiserClass.prototype.read = function (output) {
        return Codec.readBytes(output);
    };
    /**
     * Write an enum to a Buffer stream
     *
     * @param  input  the stream to which to write
     * @param  buffer the buffer of which is written
     */
    BytesSerialiserClass.prototype.write = function (input, buffer) {
        Codec.writeBytes(input, buffer);
    };
    return BytesSerialiserClass;
}());
exports.BytesSerialiserClass = BytesSerialiserClass;
/**
 * The {@link BytesSerialiserClass} singleton
 */
// tslint:disable-next-line:variable-name
exports.BytesSerialiser = new BytesSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/serialisers/bytes-serialiser.js
// module id = 1875
// module chunks = 1